
<div *ngFor="let group of groupedData" class="doc-group">
  <h3 (click)="group.collapsed = !group.collapsed" 
      style="cursor: pointer; color: #0978a2;">
    <i class="fas"
       [ngClass]="group.collapsed ? 'fa-plus' : 'fa-minus'"
       style="margin-right: 8px; color: #0978a2;"
    ></i>

    {{ group.document_name }}
  </h3>
  <div *ngIf="!group.collapsed">
    <ui-table
      [isWrapped]="false"
      [data]="group.references"
      [numberOfRows]="10"
      [displayFilter]="[]"
      [templates]="[
        {
          title: 'translate.general.refCitation',
          template: displayText
        },
        {
          title: 'translate.general.actions',
          template: actions
        }
      ]"
    ></ui-table>
  </div>
</div>

<ng-template #displayText let-row="row" >
  
  <div class="reference-container">
    <span *ngIf="!row.isEditMode" [ngClass]="{ 'placeholder': !row.reference_text?.trim() }">
      {{ row.reference_text?.trim() || ('translate.general.refPlaceholder' | translate) }}
    </span>
    
    <div *ngIf="row.isEditMode" class="edit-container">
      
      <input
        class="t-input2"
        *ngIf="row.isNewReference"
        type="text" 
        [(ngModel)]="row.reference_text"
        placeholder="{{ 'translate.cat.enterRef' | translate }}" />
      
      <p-select 
        *ngIf="!row.isNewReference"
        styleClass="reference-select"
        [options]="existingTexts"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="row.reference_text"
        placeholder="{{ 'translate.general.selectRef' | translate }}"
        [virtualScroll]="false"
        [itemSize]="35"
        [filter]="true"
        appendTo="body">
      </p-select>
      <input type="checkbox" [(ngModel)]="row.isNewReference" /> {{ "translate.cat.createRef" | translate }}
    </div>
  </div>
</ng-template>

<ng-template #actions let-row="row">
  <div class="actions-container">
    <button *ngIf="!row.isEditMode" class="t-button-icon" (click)="toggleEditMode(row)">
      <i class="fas fa-edit"></i>
    </button>
    <button *ngIf="!row.isEditMode && row.id && row.reference_text?.trim()" class="t-button-icon" (click)="deleteReference(row)" style="margin-left: 0.3rem;">
      <i class="fas fa-trash"></i>
    </button>
    <div *ngIf="row.isEditMode" class="edit-actions">
      <button class="t-button-icon" (click)="saveReferenceText(row)">
        <i class="fas fa-check"></i>
      </button>
      <button class="t-button-icon" (click)="toggleEditMode(row)">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</ng-template>
